import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class MenuIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="14" viewBox="0 0 20 14" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h20v2H0V0zm0 6h20v2H0V6zm0 6h20v2H0v-2z"/></svg>
        )
    }
}

export default withCssClassName(MenuIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/menu-icon.js